/** Screenshot rules for the feedback dialog (Freelo #32277899): image only, ≤ 5 MB. */
export const MAX_SCREENSHOT_BYTES = 5 * 1024 * 1024

export interface FileLike { name: string; type: string; size: number }

/** Returns an i18n key describing why the file is refused, or null when it is acceptable. */
export const screenshotProblem = (file: FileLike): string | null => {
  if (!file.type || !file.type.toLowerCase().startsWith('image/')) return 'Feedback_screenshot_not_image'
  if (file.size > MAX_SCREENSHOT_BYTES) return 'Feedback_screenshot_too_large'
  return null
}

/** First image file among the items of a paste/drop event, if any. */
export const imageFileFrom = (items: ArrayLike<{ kind?: string; type: string; getAsFile?: () => File | null }> | null | undefined): File | null => {
  if (!items) return null
  for (let i = 0; i < items.length; i++) {
    const it = items[i]
    if (it.type && it.type.toLowerCase().startsWith('image/') && typeof it.getAsFile === 'function') {
      const f = it.getAsFile()
      if (f) return f
    }
  }
  return null
}

export const fileToDataUrl = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
